export const RELOAD_INTERVAL_SEC = 10000;
